import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug/organizations/$organizationId')({
  staticData: {
    pageName: 'Organization Details',
  },
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/organizations/$organizationId',
      params: { organizationId: params.organizationId },
      replace: true,
    });
  },
});
